import React, { useState, useEffect, useContext } from "react";
import Nav from "react-bootstrap/Nav";
import useTheme from "./useTheme";
import Modal from "react-bootstrap/Modal";
import { LoginContext } from "../context/LoginContext";

const MessageToModir = (props) => {
  const loginContext = useContext(LoginContext);

  const [theme, switchTheme] = useTheme();

  const [showMessage, setShowMessage] = useState(false);

  const [showAnswer, setShowAnswer] = useState(false);

  const [showRes, setShowRes] = useState(false);

  const [message, setMessage] = useState("");

  const [res, setRes] = useState("");

  const [item, setItem] = useState({});

  const [myMessage, setMyMessage] = useState([]);

  const [vitrinMessage, setVitrinMessage] = useState([]);

  const [unreadMessage, setUnreadMessage] = useState(0);

  const [btnStyle, setBtnStyle] = useState("");

  const [type, setType] = useState(1);

  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    myMessageReq();
  }, []);

  const messageHandle = (e) => {
    setMessage(e.target.value);
  };

  const sendMessage = () => {
    if (message.length < 10) {
      alert("لطفا متن پیام را وارد کنید");
      return;
    }
    setIsLoading(true);
    setShowRes(true);
    setShowMessage(false);
    const formData = new FormData();
    formData.append("setMessageToModir", 1);
    formData.append("mobile", loginContext.userInfo.mobile);
    formData.append("vitrinCode", props.vitrinCode);
    formData.append("message", message);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        setRes(data.data);
        setIsLoading(false);
        console.log(data);
      })
      .catch((e) => {
        setRes("اشکال در برقراری ارتباط با سرور");
        setIsLoading(false);
        console.log(e);
      });
  };

  const myMessageReq = () => {
    const formData = new FormData();
    formData.append("getMyMessageToModir", 1);
    formData.append("mobile", loginContext.userInfo.mobile);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.data !== null) {
          setMyMessage(data.data);
          let count = 0;
          data.data.map((item) => {
            if (item.isReadMoshtari === "0" && item.answer !== "") {
              count++;
            }
          });
          setUnreadMessage(count);
        }
        console.log(data);
        setIsLoading(false);
      })
      .catch((e) => {
        setIsLoading(false);
        console.log(e);
      });
  };

  const vitrinMessageReq = () => {
    const formData = new FormData();
    formData.append("getVitrinMessageToModir", 1);
    formData.append("vitrinCode", props.vitrinCode);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        if (data.data !== null) {
          setVitrinMessage(data.data);
        }
        console.log(data);

        setIsLoading(false);
      })
      .catch((e) => {
        console.log(e);

        setIsLoading(false);
      });
  };

  const setIsRead = (pk) => {
    const formData = new FormData();
    formData.append("setIsReadMoshtariMsgToModir", 1);
    formData.append("pk", pk);
    const req = new Request(
      "https://hamrahvitrin.ir/LiveGallery/process/bonakdari_api.php",
      {
        method: "POST",
        body: formData,
      }
    );
    fetch(req)
      .then((res) => res.json())
      .then((data) => {
        console.log(data);
      })
      .catch((e) => {
        console.log(e);
      });
  };

  const closeRes = () => {
    setShowRes(false);
    setMessage("");
    setRes("");
    setShowMessage(true);
  };

  const closeAnswer = () => {
    setIsLoading(true);
    myMessageReq();
    setShowAnswer(false);
    setShowMessage(true);
  };

  const show = () => {
    if (type === 1) {
      return (
        <div className="mt-4">
          <textarea
            className={"form-control text-center rtl"}
            placeholder="متن"
            value={message}
            onChange={messageHandle}
          />
          <div className="mt-3 text-center">
            <button className="btn btn-success" onClick={sendMessage}>
              ارسال پیام
            </button>
          </div>
        </div>
      );
    } else if (type === 2) {
      return (
        <>
          <div className="row rtl m-3">
            <button
              onClick={() => {
                setType(2);
                setIsLoading(true);
                myMessageReq();
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              پیام های من
            </button>
            <button
              onClick={() => {
                setType(3);
                setIsLoading(true);
                vitrinMessageReq();
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              پیام های ویترین
            </button>
          </div>

          {!isLoading ? (
            myMessage.length === 0 ? (
              <div className="text-center">موردی یافت نشد</div>
            ) : (
              myMessage.map((item, index) => (
                <div
                  key={index}
                  className={
                    item.isReadMoshtari === "0" && item.answer !== ""
                      ? "card bg-info text-light mb-3"
                      : "card bg-light mb-3"
                  }
                >
                  <div className="card-body">
                    <p>
                      <strong>متن پیام</strong>
                    </p>
                    <p className="card-text">{item.message}</p>
                    {item.answer !== "" && item.isReadMoshtari === "1" ? (
                      <>
                        <hr />
                        <p>
                          <strong>پاسخ مدیر</strong>
                        </p>
                        <p className="card-text">{item.answer}</p>
                      </>
                    ) : null}
                  </div>

                  <div className="card-footer inlined">
                    <small>{item.date}</small>
                    {item.answer !== "" && item.isReadMoshtari === "0" ? (
                      <button
                        className="btn btn-success"
                        onClick={() => {
                          setShowAnswer(true);
                          setShowMessage(false);
                          setItem(item);
                          setIsRead(item.pkMessageToModir);
                        }}
                      >
                        مشاهده پاسخ
                      </button>
                    ) : null}
                  </div>
                </div>
              ))
            )
          ) : (
            <div className="row justify-content-center m-5 p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
        </>
      );
    } else if (type === 3) {
      return (
        <>
          <div className="row rtl m-3 ">
            <button
              onClick={() => {
                setType(2);
                setIsLoading(true);
                myMessageReq();
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              پیام های من
            </button>
            <button
              onClick={() => {
                setType(3);
                setIsLoading(true);
                vitrinMessageReq();
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              پیام های ویترین
            </button>
          </div>
          {!isLoading ? (
            vitrinMessage.length === 0 ? (
              <div className="text-center">موردی یافت نشد</div>
            ) : (
              vitrinMessage.map((item, index) => (
                <div
                  key={index}
                  className={
                    theme === "light"
                      ? "card bg-light mb-3"
                      : "card bg-light text-dark mb-3"
                  }
                >
                  <div className="card-body">
                    <p className="card-text">{item.message}</p>
                    {item.answer !== "" ? (
                      <>
                        <hr />
                        <p>
                          <strong>پاسخ مدیر</strong>
                        </p>
                        <p className="card-text">{item.answer}</p>
                      </>
                    ) : null}
                  </div>

                  <div className="card-footer inlined">
                    <small className="text-muted">{item.date}</small>
                  </div>
                </div>
              ))
            )
          ) : (
            <div className="row justify-content-center m-5 p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          )}
        </>
      );
    }
  };

  return (
    <>
      <Nav.Link
        onClick={() => {
          setShowMessage(true);
        }}
        href="#"
        className={theme === "light" ? "text-dark" : "text-light"}
      >
        {" ارتباط با مدیر "}
        {unreadMessage > 0 ? (
          <span className="badge badge-info">{unreadMessage}</span>
        ) : null}
      </Nav.Link>

      <Modal
        show={showMessage}
        onHide={() => {
          setShowMessage(false);
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <div className="row rtl mx-2">
            <button
              onClick={() => {
                setType(1);
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              ارسال پیام
            </button>
            <button
              onClick={() => {
                setType(2);
                setIsLoading(true);
                myMessageReq();
              }}
              className={
                theme === "light" ? "btn btn-dark col-6" : "btn btn-light col-6"
              }
            >
              مشاهده پیام ها
            </button>
          </div>
          {show()}
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              setShowMessage(false);
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showRes}
        onHide={() => {
          closeRes();
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          {isLoading ? (
            <div className="row justify-content-center m-5 p-5">
              <div className="spinner-border" role="status">
                <span className="sr-only">Loading...</span>
              </div>
            </div>
          ) : (
            <div>{res}</div>
          )}
        </Modal.Body>

        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              closeRes();
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>

      <Modal
        show={showAnswer}
        onHide={() => {
          closeAnswer();
        }}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        scrollable
      >
        <Modal.Header
          className={
            theme === "light"
              ? "bg-light text-dark justify-content-center"
              : "bg-dark text-light justify-content-center"
          }
        ></Modal.Header>
        <Modal.Body
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <p>
            <strong>متن پیام</strong>
          </p>
          <p className="card-text">{item.message}</p>
          <hr />
          <p>
            <strong>پاسخ مدیر</strong>
          </p>
          <p className="card-text">{item.answer}</p>
        </Modal.Body>
        <Modal.Footer
          className={
            theme === "light" ? "bg-light text-dark" : "bg-dark text-light"
          }
        >
          <button
            className="btn btn-dark"
            onClick={() => {
              closeAnswer();
            }}
          >
            بستن
          </button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default MessageToModir;
